import cn from "classnames";
import React, { forwardRef } from "react";

const DynamicButton = forwardRef((props, ref) => {
  const {
    className,
    variant = "flat",
    children,
    active,
    loading = false,
    disabled = false,
    ...rest
  } = props;

  const rootClassName = cn(
    "text-[13px] md:text-base md:leading-4 inline-flex items-center cursor-pointer transition ease-in-out duration-300 font-semibold font-body text-center justify-center border-0 border-transparent rounded-md placeholder-white focus-visible:outline-none focus:outline-none",
    {
      "bg-heading text-white px-5 md:px-6 lg:px-8 py-2 md:py-3.5 max-h-15 hover:text-white hover:bg-gray-600":
        variant === "flat",
      "h-8 lg:h-10 px-4 bg-brown text-white py-2 transform-none normal-case hover:text-white hover:bg-darkBrown":
        variant === "slim",
      "cursor-not-allowed": loading,
      "cursor-not-allowed hover:cursor-not-allowed": disabled,
      "h-auto px-4 bg-heading text-white lg:py-0 md:py-2 py-[5px] transform-none normal-case hover:text-white hover:bg-gray-600":
        variant === "cartButton",
      "w-full h-12 px-4 bg-white lg:!text-lg !text-base text-body md:py-2 py-[5px] transform-none normal-case hover:text-white hover:bg-gray-600":
        variant === "emailPopupSubmit",
    },
    className
  );

  return (
    <button
      aria-pressed={active}
      data-variant={variant}
      ref={ref}
      className={rootClassName}
      disabled={disabled}
      {...rest}
    >
      {children}
      {loading && (
        <svg
          className="animate-spin -me-1 ms-3 h-5 w-5 text-white"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          />
        </svg>
      )}
    </button>
  );
});
DynamicButton.displayName = "DynamicButton";
export default DynamicButton;
